export const BASE_URL = "https://pay.ton.org";
export const TESTNET_BASE_URL = "https://testnet.pay.ton.org";
